import { Box, Button } from '@warp-ds/react';
import { useState } from 'react';
import SafetyInfoModal from './SafetyInfoModal';

type SafetyInfoProps = {
    smallText?: boolean;
};

export const SafetyInfo = ({ smallText = false }: SafetyInfoProps) => {
    const [isSafetyInfoOpen, setIsSafetyInfoOpen] = useState(false);
    const toggleModal = () => setIsSafetyInfoOpen(!isSafetyInfoOpen);

    return (
        <Box info>
            <div className={`${smallText ? '' : 'm-16'} text-14`}>
                <div className={`${smallText ? 'h5' : 'h3'} font-bold mb-8`}>Trygg og enkel bestilling av feriehjem</div>
                <p>
                    Bestill feriehjem på en sikker og fleksibel måte. Du sender først en forespørsel til utleier - og betaler kun dersom
                    utleier godkjenner.
                </p>
                <Button
                    link
                    className={`${smallText ? 'text-14 my-4' : ' mb-12 mt-8'} font-bold`}
                    onClick={() => setIsSafetyInfoOpen(true)}>
                    Les mer
                </Button>
                <SafetyInfoModal isOpen={isSafetyInfoOpen} toggleModal={toggleModal} />
            </div>
        </Box>
    );
};

export default SafetyInfo;
